var map = {
	"./bh-ico.svg": 796,
	"./bonus-ico.svg": 797,
	"./deposit-ico.svg": 798,
	"./deposit-ico.webp": 1838,
	"./edit-icon.svg": 799,
	"./fb-ico.svg": 800,
	"./instant-rebate-ico.svg": 801,
	"./mall-ico.svg": 802,
	"./msg-ico.svg": 803,
	"./pi-ico.svg": 804,
	"./rf-ico.svg": 805,
	"./rh-ico.svg": 806,
	"./th-ico.svg": 807,
	"./vip-ico.svg": 808,
	"./withdrawal-ico.svg": 809,
	"./withdrawal-ico.webp": 1839,
	"./wl-ico.svg": 810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1837;